import { ClientConfigProductName } from '@frontend/vanilla/core';

import { allowedProductGuard, clientConfigAppGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'promo',
            // @TODO migrate SwiperJS web element to vnSwiper in bspin sub route
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('@frontend/promo/entrypoint-lib').then((t) => t.PROMO_ROUTES),
            canMatch: [allowedProductGuard, clientConfigAppGuard],
            canActivate: [productUnderMaintenanceGuard],
            data: { product: ClientConfigProductName.PROMO },
        },
    ],
};

export default routes;
